import React, { useState, useEffect, useRef } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import AnnouncementDetailsInput from './Components/AnnouncementDetailsInput'
import { adminService } from '../../../services/admin.service';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import "./AnnouncementDialog.css"
import { ObjectMapHelper } from '../../../_helpers/ObjectMapHelper';
import { createAnnouncementDto } from '../../../_mappings/Announcement';
import { FormErrorMessages } from '../../../_constants/FormErrorMessages';

const NewAnnouncementDialog = (props) => {

    const [loading, setLoading] = useState(false);
    const editorRef = useRef(null);

    const [isEmptyAnnouncementDetails,setIsEmptyAnnouncementDetails] = useState(false);
    const [invalidStartDateErrorText, setInvalidStartDateErrorText] = useState("");
    const [invalidEndDateErrorText, setInvalidEndDateErrorText] = useState("");
    const [isAnnouncementNameValid, setAnnouncementNameValid] = useState(true);

    const formReset = (isRefresh = true) =>{
        if (isRefresh) {
            props.tablesRefresh();
        }
        setIsEmptyAnnouncementDetails(false);
        props.setNewAnnouncement(false);
        props.setNewAnnouncementDto({
            startDate: null,
            endDate: null,
            announcementName: null,
            announcementDetails: null,
            us: null,
            canada: null,
            eu: null,
            ap: null,
            lac: null,
            cemea: null,
            publishState: null
        });
        
    }

    const checkFormValid = () => {
        let announcement = props.newAnnouncementDto

        if (announcement.announcementName == null || announcement.announcementName.trim().length <= 0){
            setAnnouncementNameValid(false);
            return false;
        }

        if(announcement.startDate == null && announcement.publishState == true)
        { 
            setInvalidStartDateErrorText(FormErrorMessages.FieldCannotBeBlank);
            return false;
        }

        return true
    }

    const createAnnouncement = async () => {
        setLoading(true)

        if(!checkFormValid()){
            setLoading(false);
            return;
        }

        let announcement = props.newAnnouncementDto
        let mappedDto = ObjectMapHelper.MapDto(announcement,createAnnouncementDto)

        if (announcement.publishState != true) {
            mappedDto.startDate = new Date(0);
        }
        mappedDto.endDate = announcement.endDate;
        mappedDto.announcementName = announcement.announcementName;

        if (editorRef.current) {
            if(editorRef.current.getContent().length == 0){
                setIsEmptyAnnouncementDetails(true);
                setLoading(false);
                return;
            }
            setIsEmptyAnnouncementDetails(false);
            mappedDto.announcementDetails = editorRef.current.getContent();
        }

        const Response = await adminService.CreateAnnouncement(mappedDto);
        if (Response.success) {
            props.alertObj.setSuccessMessage("Announcement successfully updated");
        } else {
            props.alertObj.setErrorMessage("Announcement failed to be updated: " + Response.error.message);
        }
        setLoading(false);
        formReset()
    }

    return (
        <>
            {loading &&
                <MCSOverlayLoading />}
            <Dialog
                aria-describedby="Create Announcement"
                onExit={() => { }}
                open={props.openNewAnnouncementDialog}
                titleId="dialog-create-announcement"
            >
                <DialogCardHead style={{height:"30px"}}>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Create Announcement</DialogCardHeadTitle>
                </DialogCardHead>
                <DialogCardBody id="dialog-description-manage-file-field">
                    <AnnouncementDetailsInput announcementDto={props.newAnnouncementDto} setAnnouncementDto={props.setNewAnnouncementDto}
                        editorRef={editorRef} invalidStartDateErrorText={invalidStartDateErrorText}
                        invalidEndDateErrorText={invalidEndDateErrorText} setInvalidStartDateErrorText={setInvalidStartDateErrorText}
                        setInvalidEndDateErrorText={setInvalidEndDateErrorText} isAnnouncementNameValid={isAnnouncementNameValid}
                        setAnnouncementNameValid={setAnnouncementNameValid} isEmptyAnnouncementDetails={isEmptyAnnouncementDetails}/>
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => {
                                formReset(false)
                            }}
                        > Cancel
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {                                
                                createAnnouncement()
                            }}
                        > Save
                        </ButtonText> 
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default NewAnnouncementDialog